import React, { useState } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import LogoSlider from '../components/LogoSlider';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    to: 'mailto:gplprabhat@gmail.com',
    name: '',
    mobile: '',
    email: '',
    subject: '',
    message: '',
    from: 'mailto:info@vstrongcontractor.com'
  });

  const [formStatus, setFormStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Form validation (optional)
    if (!formData.name || !formData.email || !formData.message) {
      setFormStatus('Please fill in all required fields.');
      return;
    }

    // Send form data to the server or email service
    console.log('Form Data:', formData);
    setFormStatus('Thank you for your inquiry. We will get back to you soon!');
    setFormData({ name: '', email: '', mobile: '', subject: '', message: '' });
  };


    return (
        <div>
        <section className="welcome-message section-padding">
        <Container>
          <Row className="justify-content-between">
            <Col lg={5} sm={12}>
            <div className="d-flex flex-column infor-di">
              
              <h2 className="title">Get In <span>Touch</span></h2>
              <p>
              Let us be part of your projects. 
                  Your vision is our mission.
              </p>
              
              <div className="welcome-list contact-list">
              <img src={require('../assets/img/home.png')} alt="home" className='img-fluid' />
              <p>1591 John F Kennedy Blvd Jersey City, NJ 07305</p>
              </div>

              <div className="welcome-list contact-list">
                <img src={require('../assets/img/mail.png')} alt="email" className='img-fluid' />
                <a href="mailto:info@vstrongcontractor.com">info@vstrongcontractor.com</a>
              </div>

              <div className="welcome-list contact-list">
                <img src={require('../assets/img/phone.png')} alt="call" className='img-fluid' />
                <a href="tel:5513929838">551-392-9838</a>
              </div>
              <div className='map'>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.9931714019617!2d-74.10144362410965!3d40.696148038586166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2510b6b3e46c3%3A0xdad58daa2aaf3fcd!2s1591%20John%20F.%20Kennedy%20Blvd%2C%20Jersey%20City%2C%20NJ%2007305%2C%20USA!5e0!3m2!1sen!2sin!4v1733831576029!5m2!1sen!2sin" width="100%" height="250" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
              </div>
            </Col>

            <Col lg={6} sm={12}>
           
            <div className='mx-auto'>
      {formStatus && <p className="form-status">{formStatus}</p>}
      <form onSubmit={handleSubmit} className='d-flex flex-column infor-di contact-box yellow-bg p-4'>
      <h2 class="title ">Write A Message</h2>
        <div className="form-group">
          <label htmlFor="name">Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            className="form-control"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="mobile">Mobile Number *</label>
          <input
            type="tel"
            id="mobile"
            name="mobile"
            className="form-control"
            value={formData.mobile}
            onChange={handleChange}
            pattern="[0-9]{10}" // Optional validation for 10-digit number
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email *</label>
          <input
            type="email"
            id="email"
            name="email"
            className="form-control"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message *</label>
          <textarea
            id="message"
            name="message"
            className="form-control"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
        </div>
        <button type="submit" className="theme-btn">
          Submit
        </button>
      </form>
      </div>
      
            </Col>
          </Row>
        </Container>
        </section>
        <section className="logo-slider">
        <Container>
            <Row>
                <Col lg={12} sm={12}>
                  <LogoSlider />
                </Col>
            </Row>
        </Container>
     </section>
    </div>
    );
}

export default ContactForm;
